import React from "react";
import { Box, Typography } from "@mui/material";
import ModalWindow from "../ModalWindow";
import { useTranslation } from "react-i18next";

interface WelcomeScheduleModalProps {
  showModal: boolean;
  setShowModal: (close: boolean) => void;
  welcomeModalSteps: number;
  onActionButtonPress?:  () => Promise<void>;
}

const WelcomeScheduleModal: React.FC<WelcomeScheduleModalProps> = ({ showModal, setShowModal, welcomeModalSteps, onActionButtonPress }) => {
  const { t } = useTranslation("dashboard");
  
  const renderBody = () => (
    <Box>
      {welcomeModalSteps !== 1 ? (
        <>
          <Typography variant="body2" mb={3}>
            {t("learnHowToScheduleContactsApps")}
          </Typography>
          <Typography variant="body1">{t("watchThisVideoToGetStarted")}</Typography>
        </>
      ) : (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: 0,
            paddingTop: "177.7778%",
            paddingBottom: 0,
            boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)",
            overflow: "hidden",
            borderRadius: "8px",
            willChange: "transform",
          }}
        >
          <iframe
            loading="lazy"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              border: "none",
              padding: 0,
              margin: 0,
            }}
            src="https://www.canva.com/design/DAGAuqfzvYM/LBNA1FqBeGmhxW9TM67dMA/watch?embed"
            allowFullScreen
            allow="fullscreen"
          ></iframe>
        </Box>
      )}
    </Box>
  );

  return (
    <ModalWindow
      headerText={
        <Typography variant="h2">
          {t("welcomeToPinwheel", { ns: "common" })}
        </Typography>
      }
      showModal={showModal}
      setShowModal={setShowModal}
      renderBody={renderBody}
      actionButtonText={t("yes", { ns: "common" })}
      onActionButtonPress={welcomeModalSteps !== 1 ? onActionButtonPress : undefined}
      cancelButtonText={welcomeModalSteps !== 1 ? t("later", { ns: "common" }) : t("close", { ns: "common" })}
      sx={{
        maxWidth: "350px",
        margin: "auto",
        "&.modal-container": {
          ".MuiDialogContent-root": {
            padding: "16px",
          },
          ".MuiDialogActions-root": {
            flexDirection: "row-reverse",
            justifyContent: "right",
          },
        },
      }}
    />
  );
};

export default WelcomeScheduleModal;
